module.exports = __webpack_public_path__ + "img/mobile/General/stest@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/stest@2x.png
// module id = 194
// module chunks = 0